module.exports = __webpack_public_path__ + "static/media/habito2.031b1130.png";